
import React from 'react';
import '../../../../assets/css/user/about/industries/Industries.css';
import industries1Img from '../../../../assets/images/home/industries1.jpg';
const Industries = () => {
  return (
    <section className="industries-section">
      <div className="container">
        
        
        <div className="row align-items-center mt-5">
          
          <div className="col-lg-6 mb-4 mb-lg-0">
            <div className="section-header-left">
          <h2 className="section-title">INDUSTRIES WE SERVE</h2>
          <div className="title-underline"></div>
        </div>
            <div className="industry-list">
              <div className="industry-item">
                <div className="yellow-l">L</div>
                <h3 className="industry-title">Agricultural Equipment Rental</h3>
              </div>
              
              <div className="industry-item">
                <div className="yellow-l">L</div>
                <h3 className="industry-title">Farm Equipment Maintenance</h3>
              </div>
              
              <div className="industry-item">
                <div className="yellow-l">L</div>
                <h3 className="industry-title">Irrigation System Solutions</h3>
              </div>
            </div>
          </div>
          
          <div className="col-lg-6">
            <img 
              src={industries1Img}
              alt="Agriculture"
              className="industries-image"
            />
          </div>
        </div>
      </div>
      
      <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet" />
    </section>
  );
};

export default Industries;